/** Owns cancellable, pause-aware waits for silent lines and inter-line gaps. */
export class PerformanceClock {
  paused = false;
  private stopped = false;
  private elapsed = 0;
  private last = performance.now();
  private waits = new Set<() => void>();

  private now(): number {
    const now = performance.now();
    if (!this.paused && !this.stopped) this.elapsed += now - this.last;
    this.last = now;
    return this.elapsed;
  }

  pause(): void {
    this.now();
    this.paused = true;
  }

  resume(): void {
    this.now();
    this.paused = false;
  }

  stop(): void {
    this.stopped = true;
    for (const cancel of this.waits) cancel();
  }

  wait(durationMs: number, onTick?: (elapsedMs: number) => void): Promise<boolean> {
    if (this.stopped) return Promise.resolve(false);
    const start = this.now();
    return new Promise((resolve) => {
      let frame: number | undefined;
      const finish = (completed: boolean) => {
        if (frame !== undefined) cancelAnimationFrame(frame);
        this.waits.delete(cancel);
        resolve(completed);
      };
      const cancel = () => finish(false);
      const tick = () => {
        const elapsed = this.now() - start;
        if (!this.paused) {
          onTick?.(elapsed);
          if (elapsed >= durationMs) return finish(true);
        }
        frame = requestAnimationFrame(tick);
      };
      this.waits.add(cancel);
      tick();
    });
  }
}
